import { render, staticRenderFns } from "./CIEDetail.vue?vue&type=template&id=15f4cb66&"
import script from "./CIEDetail.vue?vue&type=script&lang=js&"
export * from "./CIEDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports